import React, { FC } from 'react';
import { useHistory } from 'react-router-dom';
import { useMutation, useQueryClient } from 'react-query';
import { useModal } from 'store/modal';
import API from 'core/Api';
import { createErrorFromResponse } from 'core/Error';
import setServerErrors from 'utils/helpers/formErrors';

interface IProps {
  children: any;
  methods: any;
  onSuccess?: any;
  id?: string;
  entity: string;
  queryKey?: any;
  onSuccessPushToLink?: string;
  onError?: any;
}

const UpdateEntity: FC<IProps> = ({
  children,
  methods,
  onSuccess,
  entity,
  id,
  queryKey,
  onSuccessPushToLink,
  onError,
}: IProps) => {
  const { showModal } = useModal();
  const history = useHistory();
  const queryClient = useQueryClient();

  const options = {
    onSuccess: (res: any) => {
      if (queryKey) queryClient.invalidateQueries(queryKey);
      if (onSuccessPushToLink) history.push(onSuccessPushToLink);
      onSuccess(res);
    },
    onError: (res: any) => {
      const error = createErrorFromResponse(res);
      if (error.errors && typeof error.errors !== 'string') {
        if (error.errors.tokens) {
          const tksKeys = onError(res);
          const tokensErrors: any = {};
          Object.keys(error.errors.tokens).forEach(tks => {
            tokensErrors[tksKeys[tks]] = error.errors.tokens[tks].client_field_id;
          });
          return setServerErrors(tokensErrors, methods.setError);
        }
        return setServerErrors(error.errors, methods.setError);
      }
      showModal({
        type: 'error',
        content: error.message,
      });
      onError(res);
    },
  };

  const { mutate, data } = useMutation(inputData => {
    const patchUri = id ? `${entity}/${id}` : entity;
    return API.patch(patchUri, inputData);
  }, options);

  const update = (variables: any) => {
    return new Promise((resolve, reject) => {
      mutate(variables, {
        onSuccess: resolve,
        onError: reject,
      });
    });
  };

  return <>{children(update, data)}</>;
};

export default UpdateEntity;
